import type { FunctionalComponent } from 'vue';
import { h } from 'vue';

export const CloseIcon: FunctionalComponent<{ size: number }> = ({ size }) =>
  h(
    'svg',
    {
      class: 'wl-close-icon',
      viewBox: '0 0 1024 1024',
      width: size,
      height: size,
    },
    [
      h('path', {
        d: 'M697.173 85.333h-369.92c-144.64 0-241.92 101.547-241.92 252.587v348.587c0 150.613 97.28 252.16 241.92 252.16h369.92c144.64 0 241.494-101.547 241.494-252.16V337.92c0-151.04-96.854-252.587-241.494-252.587z',
        fill: 'currentColor',
      }),
      h('path', {
        d: 'm640.683 587.52-75.947-75.861 75.904-75.862a37.29 37.29 0 0 0 0-52.778 37.205 37.205 0 0 0-52.779 0l-75.946 75.818-75.862-75.946a37.419 37.419 0 0 0-52.821 0 37.419 37.419 0 0 0 0 52.821l75.947 75.947-75.776 75.733a37.29 37.29 0 1 0 52.778 52.821l75.776-75.776 75.947 75.947a37.376 37.376 0 0 0 52.779-52.821z',
        fill: '#888',
      }),
    ],
  );

export const DeleteIcon: FunctionalComponent = () =>
  h(
    'svg',
    { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'red', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'class': 'lucide lucide-trash2-icon lucide-trash-2' }, [
			h('path', {
				d: 'M3 6h18',
			}),
			h('path', {
				d: 'M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6',
			}),
			h('path', {
				d: 'M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2',
			}),
			h('line', {
				x1: '10',
				y1: '11',
				x2: '10',
				y2: '17',
			}),
			h('line', {
				x1: '14',
				y1: '11',
				x2: '14',
				y2: '17',
			}),
		]
  );

export const SpoilerIcon: FunctionalComponent<{ size: number }> = ({ size }) =>
	h(
		'svg',
		{
			viewBox: '0 0 640 512',
			width: size,
			height: size,
			xmlns: 'http://www.w3.org/2000/svg',
		},
		h('path', {
			fill: 'currentColor',
			d: 'M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z',
		}),
	);

export const EmojiIcon: FunctionalComponent = () =>
  h(
    'svg',
    { viewBox: '0 0 1024 1024', width: '24', height: '24' },
    h('path', {
      d: 'M563.2 463.3 677 540c1.7 1.2 3.7 1.8 5.8 1.8.7 0 1.4-.1 2-.2 2.7-.5 5.1-2.1 6.6-4.4l25.3-37.8c1.5-2.3 2.1-5.1 1.6-7.8s-2.1-5.1-4.4-6.6l-73.6-49.1 73.6-49.1c2.3-1.5 3.9-3.9 4.4-6.6.5-2.7 0-5.5-1.6-7.8l-25.3-37.8a10.1 10.1 0 0 0-6.6-4.4c-.7-.1-1.3-.2-2-.2-2.1 0-4.1.6-5.8 1.8l-113.8 76.6c-9.2 6.2-14.7 16.4-14.7 27.5.1 11 5.5 21.3 14.7 27.4zM387 348.8h-45.5c-5.7 0-10.4 4.7-10.4 10.4v153.3c0 5.7 4.7 10.4 10.4 10.4H387c5.7 0 10.4-4.7 10.4-10.4V359.2c0-5.7-4.7-10.4-10.4-10.4zm333.8 241.3-41-20a10.3 10.3 0 0 0-8.1-.5c-2.6.9-4.8 2.9-5.9 5.4-30.1 64.9-93.1 109.1-164.4 115.2-5.7.5-9.9 5.5-9.5 11.2l3.9 45.5c.5 5.3 5 9.5 10.3 9.5h.9c94.8-8 178.5-66.5 218.6-152.7 2.4-5 .3-11.2-4.8-13.6zm186-186.1c-11.9-42-30.5-81.4-55.2-117.1-24.1-34.9-53.5-65.6-87.5-91.2-33.9-25.6-71.5-45.5-111.6-59.2-41.2-14-84.1-21.1-127.8-21.1h-1.2c-75.4 0-148.8 21.4-212.5 61.7-63.7 40.3-114.3 97.6-146.5 165.8-32.2 68.1-44.3 143.6-35.1 218.4 9.3 74.8 39.4 145 87.3 203.3.1.2.3.3.4.5l36.2 38.4c1.1 1.2 2.5 2.1 3.9 2.6 73.3 66.7 168.2 103.5 267.5 103.5 73.3 0 145.2-20.3 207.7-58.7 37.3-22.9 70.3-51.5 98.1-85 27.1-32.7 48.7-69.5 64.2-109.1 15.5-39.7 24.4-81.3 26.6-123.8 2.4-43.6-2.5-87-14.5-129zm-60.5 181.1c-8.3 37-22.8 72-43 104-19.7 31.1-44.3 58.6-73.1 81.7-28.8 23.1-61 41-95.7 53.4-35.6 12.7-72.9 19.1-110.9 19.1-82.6 0-161.7-30.6-222.8-86.2l-34.1-35.8c-23.9-29.3-42.4-62.2-55.1-97.7-12.4-34.7-18.8-71-19.2-107.9-.4-36.9 5.4-73.3 17.1-108.2 12-35.8 30-69.2 53.4-99.1 31.7-40.4 71.1-72 117.2-94.1 44.5-21.3 94-32.6 143.4-32.6 49.3 0 97 10.8 141.8 32 34.3 16.3 65.3 38.1 92 64.8 26.1 26 47.5 56 63.6 89.2 16.2 33.2 26.6 68.5 31 105.1 4.6 37.5 2.7 75.3-5.6 112.3z',
      fill: 'currentColor',
    }),
  );

export const ImageIcon: FunctionalComponent = () =>
  h('svg', { viewBox: '0 0 1024 1024', width: '24', height: '24' }, [
    h('path', {
      d: 'M784 112H240c-88 0-160 72-160 160v480c0 88 72 160 160 160h544c88 0 160-72 160-160V272c0-88-72-160-160-160zm96 640c0 52.8-43.2 96-96 96H240c-52.8 0-96-43.2-96-96V272c0-52.8 43.2-96 96-96h544c52.8 0 96 43.2 96 96v480z',
      fill: 'currentColor',
    }),
    h('path', {
      d: 'M352 480c52.8 0 96-43.2 96-96s-43.2-96-96-96-96 43.2-96 96 43.2 96 96 96zm0-128c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm462.4 379.2-3.2-3.2-177.6-177.6c-25.6-25.6-65.6-25.6-91.2 0l-80 80-36.8-36.8c-25.6-25.6-65.6-25.6-91.2 0L200 728c-4.8 6.4-8 14.4-8 24 0 17.6 14.4 32 32 32 9.6 0 16-3.2 22.4-9.6L380.8 640l134.4 134.4c6.4 6.4 14.4 9.6 24 9.6 17.6 0 32-14.4 32-32 0-9.6-4.8-17.6-9.6-24l-52.8-52.8 80-80L769.6 776c6.4 4.8 12.8 8 20.8 8 17.6 0 32-14.4 32-32 0-8-3.2-16-8-20.8z',
      fill: 'currentColor',
    }),
  ]);

export const LikeIcon: FunctionalComponent<{ active: boolean }> = ({
  active = false,
}: {
  active?: boolean;
}) =>
  h('svg', { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'class': 'lucide lucide-thumbs-up-icon lucide-thumbs-up' }, [
    
		h('path', {
			d: `M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z`,
			fill: active ? 'currentColor' : '',
		}),
		h('path', {
      d: `M7 10v12`,
    }),
  ]);

export const PreviewIcon: FunctionalComponent = () =>
  h('svg', { viewBox: '0 0 1024 1024', width: '24', height: '24' }, [
    h('path', {
      d: 'M710.816 654.301c70.323-96.639 61.084-230.578-23.705-314.843-46.098-46.098-107.183-71.109-172.28-71.109-65.008 0-126.092 25.444-172.28 71.109-45.227 46.098-70.756 107.183-70.756 172.106 0 64.923 25.444 126.007 71.194 172.106 46.099 46.098 107.184 71.109 172.28 71.109 51.414 0 100.648-16.212 142.824-47.404l126.53 126.006c7.058 7.06 16.297 10.979 26.406 10.979 10.105 0 19.343-3.919 26.402-10.979 14.467-14.467 14.467-38.172 0-52.723L710.816 654.301zm-315.107-23.265c-65.88-65.88-65.88-172.54 0-238.42 32.069-32.07 74.245-49.149 119.471-49.149 45.227 0 87.407 17.603 119.472 49.149 65.88 65.879 65.88 172.539 0 238.42-63.612 63.178-175.242 63.178-238.943 0zm0 0',
      fill: 'currentColor',
    }),
    h('path', {
      d: 'M703.319 121.603H321.03c-109.8 0-199.469 89.146-199.469 199.38v382.034c0 109.796 89.236 199.38 199.469 199.38h207.397c20.653 0 37.384-16.645 37.384-37.299 0-20.649-16.731-37.296-37.384-37.296H321.03c-68.582 0-124.352-55.77-124.352-124.267V321.421c0-68.496 55.77-124.267 124.352-124.267h382.289c68.582 0 124.352 55.771 124.352 124.267V524.72c0 20.654 16.736 37.299 37.385 37.299 20.654 0 37.384-16.645 37.384-37.299V320.549c-.085-109.8-89.321-198.946-199.121-198.946zm0 0',
      fill: 'currentColor',
    }),
  ]);

export const MarkdownIcon: FunctionalComponent = () =>
  h(
    'svg',
    { width: '16', height: '16', ariaHidden: 'true' },
    h('path', {
      d: 'M14.85 3H1.15C.52 3 0 3.52 0 4.15v7.69C0 12.48.52 13 1.15 13h13.69c.64 0 1.15-.52 1.15-1.15v-7.7C16 3.52 15.48 3 14.85 3zM9 11H7V8L5.5 9.92 4 8v3H2V5h2l1.5 2L7 5h2v6zm2.99.5L9.5 8H11V5h2v3h1.5l-2.51 3.5z',
      fill: 'currentColor',
    }),
  );

export const ReplyIcon: FunctionalComponent = () =>
  h(
    'svg',
    { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'class': 'lucide lucide-reply-icon lucide-reply' }, [
			h('path', {
				d: 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z',
			}),
			h('path', {
				d: 'm10 15-3-3 3-3',
			}),
			h('path', {
				d: 'M7 12h7a2 2 0 0 1 2 2v1',
			}),
		]
  );

export const EditIcon: FunctionalComponent = () =>
  h(
    'svg',
    { viewBox: '0 0 24 24', width: '20', height: '20', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'class': 'lucide lucide-square-pen-icon lucide-square-pen' }, [
			h('path', {
				d: 'M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7',
			}),
			h('path', {
      	d: 'M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z',
    	}),
		]);

export const VerifiedIcon: FunctionalComponent = () =>
  h(
    'svg',
    {
      class: 'verified-icon',
      viewBox: '0 0 1024 1024',
      width: '14',
      height: '14',
    },
    h('path', {
      d: 'm894.4 461.56-54.4-63.2c-10.4-12-18.8-34.4-18.8-50.4v-68c0-42.4-34.8-77.2-77.2-77.2h-68c-15.6 0-38.4-8.4-50.4-18.8l-63.2-54.4c-27.6-23.6-72.8-23.6-100.8 0l-62.8 54.8c-12 10-34.8 18.4-50.4 18.4h-69.2c-42.4 0-77.2 34.8-77.2 77.2v68.4c0 15.6-8.4 38-18.4 50l-54 63.6c-23.2 27.6-23.2 72.4 0 100l54 63.6c10 12 18.4 34.4 18.4 50v68.4c0 42.4 34.8 77.2 77.2 77.2h69.2c15.6 0 38.4 8.4 50.4 18.8l63.2 54.4c27.6 23.6 72.8 23.6 100.8 0l63.2-54.4c12-10.4 34.4-18.8 50.4-18.8h68c42.4 0 77.2-34.8 77.2-77.2v-68c0-15.6 8.4-38.4 18.8-50.4l54.4-63.2c23.2-27.6 23.2-73.2-.4-100.8zm-216-25.2-193.2 193.2a30 30 0 0 1-42.4 0l-96.8-96.8a30.16 30.16 0 0 1 0-42.4c11.6-11.6 30.8-11.6 42.4 0l75.6 75.6 172-172c11.6-11.6 30.8-11.6 42.4 0 11.6 11.6 11.6 30.8 0 42.4z',
      fill: '#27ae60',
    }),
  );

export const StickyIcon: FunctionalComponent = () =>
  h(
    'svg',
    {
      class: 'lucide lucide-pin-icon lucide-pin',
      viewBox: '0 0 24 24',
      width: '20',
      height: '20',
			fill: 'none',
			stroke: 'currentColor',
			'stroke-width': '2',
			'stroke-linecap': 'round',
			'stroke-linejoin': 'round',
    },
		[
			h('path', {
				d: 'M12 17v5',
			}),
			h('path', {
				d: 'M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z',
			}),
		]
  );

export const LoadingIcon: FunctionalComponent<{ size?: number }> = ({
  size = 100,
}) =>
  h(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 100 100',
      preserveAspectRatio: 'xMidYMid',
    },
    h(
      'circle',
      {
        cx: 50,
        cy: 50,
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: '4',
        r: '40',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'stroke-dasharray': '85 30',
      },
      h('animateTransform', {
        attributeName: 'transform',
        type: 'rotate',
        repeatCount: 'indefinite',
        dur: '1s',
        values: '0 50 50;360 50 50',
        keyTimes: '0;1',
      }),
    ),
  );

export const GifIcon: FunctionalComponent = () =>
  h(
    'svg',
    {
      width: 24,
      height: 24,
      fill: 'currentcolor',
      viewBox: '0 0 24 24',
    },
    [
      h('path', {
        style: 'transform: translateY(0.5px)',
        d: 'M18.968 10.5H15.968V11.484H17.984V12.984H15.968V15H14.468V9H18.968V10.5V10.5ZM8.984 9C9.26533 9 9.49967 9.09367 9.687 9.281C9.87433 9.46833 9.968 9.70267 9.968 9.984V10.5H6.499V13.5H8.468V12H9.968V14.016C9.968 14.2973 9.87433 14.5317 9.687 14.719C9.49967 14.9063 9.26533 15 8.984 15H5.984C5.70267 15 5.46833 14.9063 5.281 14.719C5.09367 14.5317 5 14.2973 5 14.016V9.985C5 9.70367 5.09367 9.46933 5.281 9.282C5.46833 9.09467 5.70267 9.001 5.984 9.001H8.984V9ZM11.468 9H12.968V15H11.468V9V9Z',
      }),
      h('path', {
        d: 'M18.5 3H5.75C3.6875 3 2 4.6875 2 6.75V18C2 20.0625 3.6875 21.75 5.75 21.75H18.5C20.5625 21.75 22.25 20.0625 22.25 18V6.75C22.25 4.6875 20.5625 3 18.5 3ZM20.75 18C20.75 19.2375 19.7375 20.25 18.5 20.25H5.75C4.5125 20.25 3.5 19.2375 3.5 18V6.75C3.5 5.5125 4.5125 4.5 5.75 4.5H18.5C19.7375 4.5 20.75 5.5125 20.75 6.75V18Z',
      }),
    ],
  );

export const PlusIcon: FunctionalComponent = () =>
	h(
		'svg',
		{
			width: 24,
			height: 24,
			fill: 'currentcolor',
			viewBox: '0 0 24 24',
		},
		h('path', {
			d: 'M13 6a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5z',
		}),
	);

export const MinusIcon: FunctionalComponent = () =>
	h(
		'svg',
		{
			width: 24,
			height: 24,
			fill: 'currentcolor',
			viewBox: '0 0 24 24',
		},
		h('path', {
			fill: 'none',
			stroke:"currentColor",
			'stroke-linecap':"round",
			'stroke-linejoin':"round",
			'stroke-width':"1.5",
			d: 'M6 12h12',
		}),
	);

export const ChevronDownIcon: FunctionalComponent = () =>
	h('svg',
		{
			width: 20,
			height: 20,
			fill: 'none',
			viewBox: '0 0 24 24',
			stroke: 'currentColor',
			'stroke-width': 2,
			'stroke-linecap': 'round',
			'stroke-linejoin': 'round',
			class: 'lucide lucide-chevron-down-icon lucide-chevron-down'
		},
		h('path', {
			d: 'm6 9 6 6 6-6',
		}),
	);

export const ChevronUpIcon: FunctionalComponent = () =>
	h('svg',
		{
			width: 20,
			height: 20,
			fill: 'none',
			viewBox: '0 0 24 24',
			stroke: 'currentColor',
			'stroke-width': 2,
			'stroke-linecap': 'round',
			'stroke-linejoin': 'round',
			class: 'lucide lucide-chevron-down-icon lucide-chevron-down'
		},
		h('path', {
			d: 'm18 15-6-6-6 6',
		}),
	);